import styled from 'styled-components';

import {
  EllipsisText,
  FlexAligned,
  FlexColumn,
  FlexibleDiv,
  ImageCircle
} from '@/styled/common';

export const ChannelItemContainer = styled(FlexAligned)<{
  $isSelected: boolean;
}>`
  position: relative;
  width: 100%;
  padding: 10px 20px 10px 30px;
  background-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.bg.secondary : 'transparent'};
  text-decoration: none;
  cursor: pointer;
  border-right: ${({ theme, $isSelected }) =>
    !$isSelected && `1px solid ${theme.border.main}`};
`;

export const ChannelAdPhoto = styled(ImageCircle)<{ $imageUrl: string }>`
  width: 55px;
  height: 55px;
  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-size: cover;
  background-position: center;
`;

export const ChannelAvatar = styled(ImageCircle)<{
  $isSelected: boolean;
  $imageUrl: string;
}>`
  width: 29px;
  height: 29px;
  position: absolute;
  right: -10px;
  bottom: -10px;
  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-size: cover;
  background-position: center;
  border: ${({ theme, $isSelected }) =>
    $isSelected
      ? `2px solid ${theme.bg.secondary}`
      : `2px solid ${theme.bg.main}`};
`;

export const ChannelInfo = styled(FlexColumn)`
  margin-left: 20px;
  flex-grow: 0;
  flex-shrink: 1;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
`;

export const ChannelAdName = styled(EllipsisText)`
  width: 100%;
  color: ${({ theme }) => theme.text.main};
  font-weight: 500;
  font-size: 15px;
`;

export const ChannelMessageContainer = styled(FlexibleDiv)`
  align-items: baseline;
  max-width: 100%;
  margin-top: 5px;
`;

export const ChannelMessageContent = styled(EllipsisText)<{
  $isSelected: boolean;
}>`
  width: 100%;
  color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.text.secondary : theme.text.main};
  font-weight: ${({ $isSelected }) => ($isSelected ? 400 : 500)};
  font-size: 15px;
  max-width: fit-content;
`;

export const ChannelMessageTime = styled.div`
  width: fit-content;
  color: ${({ theme }) => theme.text.secondary};
  font-weight: 400;
  font-size: 15px;
  flex-shrink: 0;
`;

export const ChannelDotDivider = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  width: 5px;
  height: 18px;
  color: ${({ theme }) => theme.text.secondary};
`;

export const ChannelNewMessageIndicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.system.blue};
  flex-shrink: 0;
  margin-left: 10px;
`;
